import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import linkedin from "../assets/img/nav-icon1.svg";
import instagram from "../assets/img/nav-icon3.svg";
import github from "../assets/img/github.svg";

export const Footer = () => {
  const logoStyle = {
    fontFamily: "Arial, sans-serif",
    fontSize: "3em", // Adjust the font size
    fontWeight: "bold",
    color: "white", // Adjust the color
    margin: "0", // Remove default margin
  };
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <h2 style={logoStyle}>Sage</h2>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/in/sajina-pathak/"
                target={"blank"}
              >
                <img src={linkedin} alt="" />
              </a>
              <a href="https://www.instagram.com/_sajina/" target={"blank"}>
                <img src={instagram} alt="" />
              </a>
              <a href="https://github.com/sajina09/" target={"blank"}>
                <img src={github} alt="" />
              </a>
            </div>
            <p>Copyright 2025. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
